import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { DsSideModalComponent } from "../components/ds-side-modal/ds-side-modal.component";
import { DsSideModalConfig } from "../components/types/side-modal.types";

@Injectable({
  providedIn: "root",
})
export class DsSideModalService {
  private static readonly DEFAULT_WIDTH = "720px";

  constructor(private dialog: MatDialog) {}

  open(config: DsSideModalConfig): MatDialogRef<DsSideModalComponent> {
    const side = config.side ?? "right";
    const width = config.width ?? DsSideModalService.DEFAULT_WIDTH;

    const defaultConfig: MatDialogConfig = {
      autoFocus: config.autoFocus ?? false,
      disableClose: config.disableClose ?? true,
      restoreFocus: config.restoreFocus ?? false,
      closeOnNavigation: config.closeOnNavigation ?? true,
      panelClass: ["ds-side-modal-panel", `ds-side-modal-panel--${side}`, ...(config.panelClass || [])],
      width,
      maxWidth: "90vw",
      height: "100dvh",
      hasBackdrop: true,
      data: {
        title: config.title,
        description: config.description,
        titleDsIcon: config.titleDsIcon,
        innerComponent: config.innerComponent || null,
        innerComponentData: config.data,
        side,
      },
    };

    return this.dialog.open(DsSideModalComponent, defaultConfig);
  }
}
